import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOverview () {
    return Api().get('/v1/subscriptions')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.GetSubscriptionsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async get (uid) {
    return Api().get('/v1/subscriptions/' + uid)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.GetSubscriptionErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getCustomerSubscriptions (customerUid) {
    return Api()
    .get('/v1/subscriptions/getCustomerSubscriptions?endCustomerUid=' + customerUid)
    .then(async function (response) {
      return { success: true, value: response.data }
    })
    .catch(async function (error) {
      await Store.dispatch('SetSnackBarMessage', {
        message: i18n.t('Services.Subscriptions.Messages.GetCustomerSubscriptionsErrorMessage'),
        color: 'error',
      })
      console.error(error)
      return { success: false }
    })
  },
  async cancelSubscription (subscriptionUid) {
    return Api()
      .patch('/v1/subscriptions/' + subscriptionUid + '/cancel')
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.CancelSubscriptionSuccessMessage', [subscriptionUid.substr(0, 6)]),
          color: 'success',
        })
        return { success: true, value: subscriptionUid }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.CancelSubscriptionErrorMessage', [subscriptionUid.substr(0, 6)]),
          color: 'error',
        })
        console.error(error) // todo what to do?
        return { success: false }
      })
  },
  async updateQuantity (subscriptionUid, newQuantity) {
    return Api()
      .patch('/v1/subscriptions/' + subscriptionUid + '/updateQuantity?newQuantity=' + newQuantity)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.UpdateQuantitySuccessMessage'),
          color: 'success',
        })
        // todo, do something with the requestId?
        return { success: true }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.UpdateQuantityErrorMessage'),
          color: 'error',
        })
        console.error(error) // todo what to do?
        return { success: false }
      })
  },

  // Todo: Remove when we have a functional SignalR Hub
  async getForCustomer (params) {
    return Api()
      .get('/v1/subscriptions/ForCustomer/?customerId=' + params.customerId + '&variantId=' + params.variantId)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Subscriptions.Messages.GetForCustomerErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
